  // class CkFaqs extends HTMLElement {
  //   constructor(){
  //     super();
  //     this.faqItems = this.querySelectorAll('.faq-item');
  //     this.init();
  //   }
  //   init(){
  //     this.faqItems.forEach((item) => {
  //       const question = item.querySelector('.faq-question');
  //       const answer   = item.querySelector('.faq-answer');

  //       question.addEventListener('click', () => {
  //       const isOpen = item.classList.contains('open');

  //       this.faqItems.forEach((el) => {
  //         const ans = el.querySelector('.faq-answer');
  //         el.classList.remove('open');
  //         ans.style.maxHeight = null;
  //       });

  //       if (!isOpen) {
  //         item.classList.add('open');
  //         answer.style.maxHeight = answer.scrollHeight + 'px';
  //       }
  //       })
  //     })
  //   }
  // }


  // customElements.define('ck-faq', CkFaqs);


  class CkFaqs extends HTMLElement {
  constructor() {
    super();
    this.faqItems = this.querySelectorAll('.faq-item');
    this.init();
  }

  init() {
    this.faqItems.forEach((item) => {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');

      question.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');

        this.faqItems.forEach((el) => {
          const ans = el.querySelector('.faq-answer');
          el.classList.remove('open');
          ans.style.maxHeight = null;
        });

        if (!isOpen) {
          item.classList.add('open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });

    // 👉 Open the first FAQ item when page loads
    const firstItem = this.faqItems[0];
    if (firstItem) {
      firstItem.classList.add('open');
      const firstAnswer = firstItem.querySelector('.faq-answer');
      firstAnswer.style.maxHeight = firstAnswer.scrollHeight + 'px';
    }
  }
}

customElements.define('ck-faq', CkFaqs);

